import React from 'react';
import { cn } from './ui/utils';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'strong' | 'light';
  withWaveEffect?: boolean;
  hoverable?: boolean;
}

export const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className,
  variant = 'default',
  withWaveEffect = false,
  hoverable = true
}) => {
  const variants = {
    default: 'bg-white/10 backdrop-blur-md border border-white/20',
    strong: 'bg-white/20 backdrop-blur-xl border border-white/30',
    light: 'bg-white/5 backdrop-blur-sm border border-white/10'
  };

  return (
    <div 
      className={cn(
        // Base glass effect using standard Tailwind utilities
        variants[variant],
        'rounded-2xl p-6 shadow-lg',
        
        // Hover effects
        hoverable && 'transition-all duration-300 hover:bg-white/15 hover:border-white/40 hover:translate-y-[-2px] hover:shadow-xl',
        
        // Wave effects
        withWaveEffect && 'wave-float wave-optimized',
        
        // Performance optimization
        'transform-gpu will-change-transform',
        
        // Custom className
        className
      )}
    >
      {/* Wave effect lines */}
      {withWaveEffect && (
        <div className="absolute inset-0 overflow-hidden rounded-2xl">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/30 to-transparent wave-animation" />
          <div 
            className="absolute bottom-0 right-0 w-full h-1 bg-gradient-to-r from-transparent via-white/20 to-transparent wave-animation" 
            style={{ animationDelay: '1s' }} 
          />
        </div>
      )}
      
      {/* Content */}
      <div className={cn('relative z-10', withWaveEffect && 'relative')}>
        {children}
      </div>
    </div>
  );
};